import styled from 'styled-components';
const Svg = styled.svg `
  display: block;
`;
export const Styled = {
    Svg,
};
//# sourceMappingURL=butterfly.styles.js.map